/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { AssetGallerySectionFragment } from "@cosmos/hygraph-schema";
import { cx } from "@panda/css";
import { VStack } from "@panda/jsx";
import { ResponsiveContainer, SectionContainer, SectionHeading, BackgroundContainer } from "@components/elements";
import { AssetGallery } from "./AssetGallery.molecule";

export interface AssetGallerySectionProps extends AssetGallerySectionFragment {
	className?: string;
}

export const AssetGallerySection = ({
	className,
	config,
	assets,
}: AssetGallerySectionProps): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(assets?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlockEnd={!!config?.disablePaddingBottom}>
					<VStack alignItems="stretch" gap="eds.dimension.96" className={cx("asset-gallery-section", className)}>
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? <AssetGallery assets={assets} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
